import {
  ANALYSIS_WIDGET_MIN_HEIGHT,
  MIN_ROW_HEIGHT,
} from '@modules/dashboard/constants';
import { DashboardLayout, DashboardViewFragment } from 'generated/graphql';

interface GetCellMinimumHeightsByRowIDParams {
  layout: DashboardLayout | undefined;
  widgets: DashboardViewFragment['widgets'];
  baseCellMinimumHeightsByRowID?: Record<string, Record<string, number>>;
}

export function getCellMinimumHeightsByRowID({
  layout,
  widgets,
  baseCellMinimumHeightsByRowID,
}: GetCellMinimumHeightsByRowIDParams) {
  const cellMinimumHeightsByRowID: Record<string, Record<string, number>> = {};

  return (
    layout?.rows.reduce((acc, row) => {
      acc[row.id] = {};
      row.cells.forEach((cell) => {
        const defaultMinHeight = widgets?.find(
          (widget) => widget.id === cell.contentID,
        )?.analysis
          ? ANALYSIS_WIDGET_MIN_HEIGHT
          : MIN_ROW_HEIGHT;

        acc[row.id][cell.id] =
          baseCellMinimumHeightsByRowID?.[row.id]?.[cell.id] ??
          defaultMinHeight;
      });

      return acc;
    }, cellMinimumHeightsByRowID) ?? cellMinimumHeightsByRowID
  );
}
